import { apiClient } from '@/services/ApiClient'

export const getApprovals = (query) => {
  return apiClient
    .get('dual-guard/actions', {
      params: query
    })
    .then(response => {
      return response
    })
    .catch(err => {
      throw err
    })
}

export const getApproval = id => {
  return apiClient
    .get(`dual-guard/actions/${id}`)
    .then(response => {
      return response
    })
    .catch(err => {
      throw err
    })
}

export const update = (id, decision, reviewNotes, shouldNotifyExpiredResidenceCertificate = null) => {
  return apiClient
    .patch(`dual-guard/actions/${id}`, { decision, review_notes: reviewNotes, should_notify_expired_residence_certificate: shouldNotifyExpiredResidenceCertificate })
    .then(response => {
      return response
    })
    .catch(err => {
      throw err
    })
}